import React from "react";

import "./ChartWrapper.css";

export const ChartWrapper: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="chart-wrapper">{children}</div>;
